import { WidgetPageGlasgowState } from './widgetPageGlasgow/widgetPageGlasgow.initialState';
import { WidgetPageDublinState } from './widgetPageDublin/widgetPageDublin.initialState';

type WidgetPageAction = { type: string };

type WidgetPageState = WidgetPageGlasgowState | WidgetPageDublinState;

export const widgetPageReducer = (state: WidgetPageState = {} as WidgetPageState, action: WidgetPageAction) => {
  switch (action.type) {
    default:
      return state;
  }
};
